import { formatNumber, ParsedNumber, parseNumber } from "libphonenumber-js";

export const US_PHONE_MASK = [
  "(",
  /[1-9]/,
  /\d/,
  /\d/,
  ")",
  " ",
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const formatPhone = (num: string | null): string => {
  if (!(typeof num === "string")) return "";

  try {
    const parsed = parseNumber(num, "US");
    if (Object.keys(parsed).length === 0) return num;
    const formatted = formatNumber(parsed as ParsedNumber, "NATIONAL");
    return formatted;
  } catch (e) {
    console.error("Error formatting phone number", e, num);
    return num;
  }
};
